import axios from "axios";
const BASE = "https://jx7oqj6b4i.execute-api.ap-south-1.amazonaws.com/production";

export const dpdToday = () => axios.get(`${BASE}/dpd/today`);
export const dpdYesterday = () => axios.get(`${BASE}/dpd/yesterday`);
export const dpdLast7 = () => axios.get(`${BASE}/dpd/last7days`);
export const dpdLast30 = () => axios.get(`${BASE}/dpd/last30days`);

export const dpdRange = (start, end) =>
  axios.get(`${BASE}/dpd/range`, { params: { start, end } });
